module.exports = "/_next/static/chromiums/og-1200x630-products-strawberry-creme-organic-lip-balm-6cb5feab21be0ded9bfe076746f5221d.jpg";